import { State } from 'vuex-simple';
import IframeApsModule from '@/HostApp/store/ApsModules/IframeApsModule';

export class SharedContext {
	@State()
	public contextMap: Common.IMap<IframeApsModule> = {};

	public createApsContext(appId: string, view: APS.IView): IframeApsModule {
		const iframeApsModule = new IframeApsModule();

		this.contextMap[appId] = iframeApsModule;

		return iframeApsModule;
	}

	public getApsModuleById(viewId: string = ''): IframeApsModule | undefined {
		const id = viewId.split('#')[0];

		return this.contextMap[id];
	}
}

const sharedContext = new SharedContext();

export default sharedContext;
